import { dataHighSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHighSquareSolid = /*#__PURE__*/createIcon(dataHighSquareSolid)
export default IconHighSquareSolid
